import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PageNotFoundComponent {
}

